export class SendAccessRequest {
  password: string;
}
